import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export function LoginPromptCard() {
  return (
    <Card className="shadow-lg h-fit">
      <CardHeader className="text-left pb-6">
        <CardTitle className="text-foreground font-semibold text-xl">Already have an account?</CardTitle>
        <p className="text-muted-foreground text-sm">
          Sign in to continue your succession planning journey
        </p>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <Button asChild variant="outline" className="w-full">
            <Link to="/login">
              Sign in to your account
            </Link>
          </Button>
          
          <div className="text-center">
            <p className="text-xs text-muted-foreground">
              Secure • Protected • Confidential
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}